import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SmoothScrollbarState {
  scrollbar: unknown;
  current: unknown;
}

const initialState: SmoothScrollbarState = {
  scrollbar: null,
  current: null,
};

export const smoothScrollbarSlice = createSlice({
  name: "scrollbar",
  initialState,
  reducers: {
    setScrollbar: (state, action: PayloadAction<unknown>) => {
      state.current = action.payload;
      state.scrollbar = action.payload;
    },
  },
});

export const { setScrollbar } = smoothScrollbarSlice.actions;

export default smoothScrollbarSlice.reducer;
